  import fbPixelEvent from "../../../data/fbPixelEvent"; // Adjust path if necessary, assuming it's sibling to tracking/
  
  /**
   * Creates an event data object for Facebook Pixel based on event name and data data.
   * @param {string} eventName - The name of the Facebook Pixel event.
   * @param {object} data - The data data containing information for the event.
   * @returns {object} The formatted event data object.
   */
  export function createEventObject(eventName, data) {
    const eventData = {};
    const expectedParams = fbPixelEvent[eventName] || [];
  
    // Set common defaults, which can be overridden by specific data.
    eventData.currency = data.currency || "IDR";
    eventData.content_type = data.content_type || "product";
    eventData.fbc = data.fbc; // Facebook Click ID from the browser
    eventData.fbp = data.fbp; // Facebook Browser ID from the browser
    eventData.event_time = data.event_time; // Facebook Browser ID from the browser
  
    // Populate eventData with expected parameters directly from the 'data' object.
    // The assumption is that 'data' already contains these properties with correct values.
    console.log({expectedParams, data})
    for (const paramName of expectedParams) {
      if (data[paramName] !== undefined) {
        eventData[paramName] = data[paramName];
      } else if (eventData[paramName] === undefined) {
        // For standard events, if a required parameter is missing, set to null
        // for consistency in pixel payload, allowing Facebook to identify missing data.
        eventData[paramName] = null;
      }
    }
    return eventData;
  }

  /**
   * @param {string} [scope] - Order identity (trackingEventKey) so "once" is once per order, not once per tab.
   */
  export async function checkTrackingConversion(context, key, globalConversionSetting, scope) {
    const trackingConversion = context.trackingConversion === "global"
      ? globalConversionSetting
      : context.trackingConversion;
    const conversionSetting = trackingConversion || context.globalConversionSetting;

    if (conversionSetting === "once") {
      const result = checkSession(scope ? `${key}_${scope}` : key);
      if (result) return false;
    }

    return true;
  }
  
  export function checkSession(key) {
    if (sessionStorage.getItem(key)) {
      return true;
    }
    sessionStorage.setItem(key, true);
    return false;
  }
